export const emptyValuesToNull = values =>
  Object.entries(values).reduce(
    (vals, [key, value]) => ({
      ...vals,
      [key]: value !== "" ? value : null
    }),
    {}
  );
